import React from 'react';
import {Alert, Row, Button, Col} from "rsuite";
import {connect} from 'react-redux';
import {createStructuredSelector} from "reselect";
import {
    selectBaseTime,
    selectCounter,
    selectIconsLayer,
    selectIsLive,
    selectIsMain, selectLivePath,
    selectMap, selectMountLiveTime,
    selectReportLayer, selectTimer
} from "../../redux/map/map.selector";
import mapTypes from "../../redux/map/map.types";
import {selectToken, selectUserInfo} from "../../redux/user/user.selector";
import {
    selectCarIcons, selectCarsData,
    selectInterval,
    selectPlayPause, selectReportIndex,
    selectReports,
    selectSelectedCarInfo,
    selectSingleCarData
} from "../../redux/cars/cars.selector";
import Axios from "axios";
//import Sound
import StartSound from '../../assets/soundEffect/start.mp3';
import EndSound from '../../assets/soundEffect/stop.mp3';

import './live.style.sass';
import * as L from "leaflet";
import CloseBTN from '../../assets/icons/delete.png';
import {GetCarsData, GetReports, SetIcons, SetInterval, SetReportIndex} from "../../redux/cars/cars.action";
import {
    SetMountLiveTime,
    SetIconsLayer,
    SetTimer,
    SetCounterLiveShowTime,
    SetLivePath, AddReportLayer
} from "../../redux/map/map.actions";
import carsTypes from "../../redux/cars/cars.types";
import {antPath} from "leaflet-ant-path";
import PointMarker from '../../assets/icons/lock_back1.png';
import carg from "../../assets/icons/carg.png";
import carr from "../../assets/icons/carr.png";
import cargr from "../../assets/icons/cargr.png";
import cary from "../../assets/icons/car_y.png";
import vanr from "../../assets/icons/van_red.png";
import vangr from "../../assets/icons/van_gr.png";
import vany from "../../assets/icons/van_y.png";
import vang from "../../assets/icons/van_green.png";
import truckr from "../../assets/icons/truck_red.png";
import truckgr from "../../assets/icons/truck_gr.png";
import trucky from "../../assets/icons/truck_y.png";
import truckg from "../../assets/icons/truck_green.png";
import taxir from "../../assets/icons/taxi_red.png";
import taxigr from "../../assets/icons/taxi_gr.png";
import taxiy from "../../assets/icons/taxi_yl.png";
import taxig from "../../assets/icons/taxi_green.png";
import busr from "../../assets/icons/bus_red.png";
import busgr from "../../assets/icons/bus_gr.png";
import busy from "../../assets/icons/bus_Y.png";
import busg from "../../assets/icons/bus_green.png";
import motorr from "../../assets/icons/motor_red.png";
import motorgr from "../../assets/icons/motor_gr.png";
import motory from "../../assets/icons/motor_y.png";
import motorg from "../../assets/icons/motor_green.png";
import bicycler from "../../assets/icons/bicycle_red.png";
import bicyclegr from "../../assets/icons/bicycle_gr.png";
import bicycleg from "../../assets/icons/bicycle_green.png";
import shipr from "../../assets/icons/ship_red.png";
import shipgr from "../../assets/icons/ship_gr.png";
import shipy from "../../assets/icons/ship_y.png";
import shipg from "../../assets/icons/ship_green.png";
import metror from "../../assets/icons/metro_red.png";
import metrogr from "../../assets/icons/metro_gr.png";
import metroy from "../../assets/icons/metro_y.png";
import metrog from "../../assets/icons/metro_green.png";
import ambolancer from "../../assets/icons/ambolance_red.png";
import ambolancegr from "../../assets/icons/ambolance_gr.png";
import ambolancey from "../../assets/icons/ambolance_y.png";
import ambolanceg from "../../assets/icons/ambolance_green.png";
import dogr from "../../assets/icons/dog_red.png";
import doggr from "../../assets/icons/dog_gr.png";
import dogg from "../../assets/icons/dog_green.png";
import personr from "../../assets/icons/person_red.png";
import persongr from "../../assets/icons/person_gr.png";
import persong from "../../assets/icons/person_green.png";
import {BiggerTime, ToPersianDate} from "../../script";

class LiveComponent extends React.Component {

    componentDidMount() {
        const {
            getUser, singleCarData, getMap, setIconsLayer, getMarkerLayers, getReportLayer, ClearIconsLayer,
            ClearReportLayer, SetReportIndex, setReports, getInterval, SetInterval, playPause, TogglePlayPause,
            getReports, singleCarInfo, StartCountDown, SetTimer, SetMountLiveTime, getMountLiveTime, SetIcons, CarsData
        } = this.props;


        const dayInMS = 1000 * 60 * 60 * 24;
        const Now = Math.floor(new Date().getTime());
        const day5 = new Date(Now - (dayInMS * 5)).getTime();
        const day3 = new Date(Now - (dayInMS * 3)).getTime();

        let MountLiveTime = Math.floor((new Date().getTime() / 1000.0) - 50);
        SetMountLiveTime(MountLiveTime);
        let map = getMap;
        /** CLEAR MAP */
        if (getMarkerLayers) {
            getMarkerLayers.map(item => map.removeLayer(item));
            ClearIconsLayer();
        }
        if (getReportLayer) {
            getReportLayer.map(item => map.removeLayer(item));
            ClearReportLayer();
            SetReportIndex(0);
        }
        if (getInterval) {
            clearInterval(getInterval);
            SetInterval(0);
        }
        if (playPause) {
            TogglePlayPause();
        }
        if (getReports.length) {
            setReports([])
        }
        let Data = {
            phone: getUser.phone,
            pass: getUser.pass,
            id: singleCarData.DeviceID
        };

        let arr = [];
        arr.push(singleCarData);
        SetLivePath(arr);

        /** SET MARKER */

        let car = CarsData.find((x) => x.DeviceID == singleCarData.DeviceID);
        let markersLayer;
        let iconUrl = carg;

        switch (car.Application) {
            case 0:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = carr
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = cargr
                } else if (car.Switch) {
                    iconUrl = cary
                } else {
                    iconUrl = carg
                }
                break;
            case 1:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = vanr
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = vangr
                } else if (car.Switch) {
                    iconUrl = vany
                } else {
                    iconUrl = vang
                }
                break;
            case 2:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = truckr
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = truckgr
                } else if (car.Switch) {
                    iconUrl = trucky
                } else {
                    iconUrl = truckg
                }
                break;
            case 3:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = taxir
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = taxigr
                } else if (car.Switch) {
                    iconUrl = taxiy
                } else {
                    iconUrl = taxig
                }
                break;
            case 4:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = busr
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = busgr
                } else if (car.Switch) {
                    iconUrl = busy
                } else {
                    iconUrl = busg
                }
                break;
            case 5:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = motorr
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = motorgr
                } else if (car.Switch) {
                    iconUrl = motory
                } else {
                    iconUrl = motorg
                }
                break;
            case 6:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = bicycler
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = bicyclegr
                } else {
                    iconUrl = bicycleg
                }
                break;
            case 7:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = shipr
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = shipgr
                } else if (car.Switch) {
                    iconUrl = shipy
                } else {
                    iconUrl = shipg
                }
                break;
            case 8:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = metror
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = metrogr
                } else if (car.Switch) {
                    iconUrl = metroy
                } else {
                    iconUrl = metrog
                }
                break;
            case 9:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = ambolancer
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = ambolancegr
                } else if (car.Switch) {
                    iconUrl = ambolancey
                } else {
                    iconUrl = ambolanceg
                }
                break;
            case 10:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = dogr
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = doggr
                } else {
                    iconUrl = dogg
                }
                break;
            case 11:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = personr
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = persongr
                } else {
                    iconUrl = persong
                }
                break;
            default:
                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                    iconUrl = carr
                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                    iconUrl = cargr
                } else if (car.Switch) {
                    iconUrl = cary
                } else {
                    iconUrl = carg
                }
                break;
        }

        let icon = L.icon({
            iconUrl: iconUrl,
            iconAnchor: [15, 22],
            popupAnchor: [0, -20],
            iconSize: new L.Point(30, 45)
        });

        SetIcons(icon);

        markersLayer = new L.marker([car.Latitude, car.Longitude], {
            icon: icon,
            rotationAngle: car.COG * 30
        });

        let myPopup = `
                                 <b>${car.Name}</b><br>
                                 <span>${ToPersianDate(car.Date)}</span><br/>
                                 <span>وضعیت سویچ : ${car.Switch ? 'باز' : 'بسته'}</span><br/>
                                 <span>وضعیت درب ها : ${car.Door ? 'باز' : 'بسته'}</span><br/>
                                 <span>سرعت : ${car.Speed ? `${car.Speed} کیلومتر` : 'ساکن'}</span><br/>
                                 <span>دما : ${car.Temperature}</span><br />
                                 <span>وضعیت رله : ${car.Relay ? "قطع" : "وصل"}</span><br />
                        `;

        markersLayer.bindPopup(myPopup);
        let layerOfMarks = L.layerGroup([markersLayer]);
        map.addLayer(layerOfMarks);
        setIconsLayer(markersLayer);

        /** SET TIMER */
        let timer = setInterval(() => StartCountDown(), 1000);
        SetTimer(timer);

    }

    componentDidUpdate(prevProps) {
        const {
            singleCarInfo, SelectCounter, ClearIconsLayer, RefreshCounter, getUser, singleCarData, getMap, setCarsData,
            getMarkerLayers, getIcon, getMountLiveTime, CarsData, setIconsLayer, SetLivePath, getLivePath, getUserInfo,
            getReportIndex, setReportIndex, setReportLayer, getReportLayer, getToken
        } = this.props;


        const dayInMS = 1000 * 60 * 60 * 24;
        const Now = Math.floor(new Date().getTime());
        const day5 = new Date(Now - (dayInMS * 5)).getTime();
        const day3 = new Date(Now - (dayInMS * 3)).getTime();

        let map = getMap;

        if (SelectCounter === 0 && prevProps.SelectCounter === 1) {
            let Data = {
                phone: getUser.phone,
                pass: getUser.pass,
                id: singleCarData.DeviceID,
                last_time: `${getMountLiveTime}`
            };
            /** THIS IS CAUSE WE HAVE DOUBLE REQUEST ON API */
            Axios.post(`${getToken}/lastCar`, JSON.stringify(Data))
                .then(res => {
                    if (res.data.data.length) {
                        SetLivePath(res.data.data);
                    }
                    let CarsInfo = res.data.data;

                    if (CarsInfo.length && prevProps.getLivePath.length !== CarsInfo.length) {
                        // CLEAR MAP
                        if (getMarkerLayers) {
                            getMarkerLayers.map(item => map.removeLayer(item));
                            ClearIconsLayer();
                        }
                        /** ANT PATH START */
                        let arrs = [];
                        CarsInfo.map(item => {
                            arrs.push([item.Latitude, item.Longitude]);
                        });

                        const path = antPath(arrs, {
                            "paused": false,
                            "reverse": false,
                            "delay": 2000,
                            "dashArray": [3, 100],
                            "weight": 5,
                            "opacity": 0.6,
                            "color": "#0000FF",
                            "pulseColor": "#FFFFFF",
                        });

                        // PLAY AUDIO
                        if (prevProps.getLivePath[prevProps.getLivePath.length - 1].Switch !== CarsInfo[CarsInfo.length - 1].Switch) {
                            if (CarsInfo[CarsInfo.length - 1].Switch === 1) {
                                let startAudio = new Audio(StartSound);
                                startAudio.play();
                            } else {
                                let endAudio = new Audio(EndSound);
                                endAudio.play();
                            }
                        }

                        let LiveShowLayer = L.layerGroup([path]);

                        /** SET ANIMATION MARKER */
                        CarsInfo.map(item => {
                            let markerIcon = L.icon({
                                iconUrl: PointMarker,
                                iconAnchor: [4, 4],
                                popupAnchor: [0, -20],
                                iconSize: new L.Point(8, 8)
                            });

                            /** Marker PopUp */

                            let Dots = L.marker([item.Latitude, item.Longitude], {
                                icon: markerIcon,
                                zIndexOffset: 1
                            }).addTo(LiveShowLayer)
                                .bindPopup(`
                                                    <span>نقطه شماره ${item.ID}</span><br />
                                                    <span>${ToPersianDate(item.Date)}</span><br />
                                                    <span>دما : ${item.Temperature}</span><br />
                                                    <span>سرعت : ${item.Speed} کیلومتر</span><br />
                                                `).addTo(LiveShowLayer);
                        });

                        /** SET MARKER */

                        let car = CarsData.find((x) => x.DeviceID == singleCarData.DeviceID);
                        let markersLayer;
                        let iconUrl = carg;
                        let LastDebitUpdateDiff = parseInt(singleCarData.SimDebitLastUpdate) - singleCarData.Time;

                        //SWITCH
                        switch (car.Application) {
                            case 0:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = carr
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = cargr
                                } else if (car.Switch) {
                                    iconUrl = cary
                                } else {
                                    iconUrl = carg
                                }
                                break;
                            case 1:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = vanr
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = vangr
                                } else if (car.Switch) {
                                    iconUrl = vany
                                } else {
                                    iconUrl = vang
                                }
                                break;
                            case 2:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = truckr
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = truckgr
                                } else if (car.Switch) {
                                    iconUrl = trucky
                                } else {
                                    iconUrl = truckg
                                }
                                break;
                            case 3:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = taxir
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = taxigr
                                } else if (car.Switch) {
                                    iconUrl = taxiy
                                } else {
                                    iconUrl = taxig
                                }
                                break;
                            case 4:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = busr
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = busgr
                                } else if (car.Switch) {
                                    iconUrl = busy
                                } else {
                                    iconUrl = busg
                                }
                                break;
                            case 5:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = motorr
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = motorgr
                                } else if (car.Switch) {
                                    iconUrl = motory
                                } else {
                                    iconUrl = motorg
                                }
                                break;
                            case 6:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = bicycler
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = bicyclegr
                                } else {
                                    iconUrl = bicycleg
                                }
                                break;
                            case 7:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = shipr
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = shipgr
                                } else if (car.Switch) {
                                    iconUrl = shipy
                                } else {
                                    iconUrl = shipg
                                }
                                break;
                            case 8:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = metror
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = metrogr
                                } else if (car.Switch) {
                                    iconUrl = metroy
                                } else {
                                    iconUrl = metrog
                                }
                                break;
                            case 9:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = ambolancer
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = ambolancegr
                                } else if (car.Switch) {
                                    iconUrl = ambolancey
                                } else {
                                    iconUrl = ambolanceg
                                }
                                break;
                            case 10:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = dogr
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = doggr
                                } else {
                                    iconUrl = dogg
                                }
                                break;
                            case 11:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = personr
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = persongr
                                } else {
                                    iconUrl = persong
                                }
                                break;
                            default:
                                if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day5 / 1000)) {
                                    iconUrl = carr
                                } else if (BiggerTime(singleCarData.SimDebitLastUpdate, singleCarData.Time) < (day3 / 1000)) {
                                    iconUrl = cargr
                                } else if (car.Switch) {
                                    iconUrl = cary
                                } else {
                                    iconUrl = carg
                                }
                                break;
                        }

                        let icon = L.icon({
                            iconUrl: iconUrl,
                            iconAnchor: [15, 22],
                            popupAnchor: [0, -30],
                            iconSize: new L.Point(30, 45)
                        });

                        map.flyTo([CarsInfo[CarsInfo.length - 1].Latitude, CarsInfo[CarsInfo.length - 1].Longitude], 16, {duration: 3});

                        markersLayer = L.marker([CarsInfo[CarsInfo.length - 1].Latitude, CarsInfo[CarsInfo.length - 1].Longitude], {
                            icon: icon,
                            rotationAngle: CarsInfo[CarsInfo.length - 1].COG * 30,
                            zIndexOffset: 2
                        }).bindPopup(`
                                                     <b>${car.Name}</b><br>
                                                     <span>${ToPersianDate(CarsInfo[CarsInfo.length - 1].Date)}</span><br/>
                                                     <span>وضعیت سویچ : ${CarsInfo[CarsInfo.length - 1].Switch ? 'باز' : 'بسته'}</span><br/>
                                                     <span>سرعت : ${CarsInfo[CarsInfo.length - 1].Speed ? `${CarsInfo[CarsInfo.length - 1].Speed} کیلومتر` : 'ساکن'}</span><br/>
                                                     <span>دما : ${CarsInfo[CarsInfo.length - 1].Temperature}</span><br />
                                                     <span>وضعیت رله : ${CarsInfo[CarsInfo.length - 1].Relay ? "قطع" : "وصل"}</span><br />
                                            `).addTo(LiveShowLayer);

                        map.addLayer(LiveShowLayer);
                        setIconsLayer(markersLayer);
                        setIconsLayer(LiveShowLayer);
                        markersLayer.openPopup();
                    }
                    RefreshCounter(document.getElementById('chooseLiveRefresher').value);
                })
        }
        // if (SelectCounter < -1) {
        //     RefreshCounter(document.getElementById('chooseLiveRefresher').value);
        // }
    }

    componentWillUnmount() {
        const {getTimer,} = this.props;
        clearInterval(getTimer)
    }

    render() {
        const {ToggleIsLive, RefreshCounter, isMain, ToggleIsMain, SelectCounter, singleCarInfo} = this.props;
        const HandleExit = () => {
            ToggleIsLive();
            if (!isMain) {
                ToggleIsMain()
            }

        };

        const ChooseLiveRefresher = () => {
            let Value = document.getElementById('chooseLiveRefresher').value;
            RefreshCounter(Value);
        };
        return (
            <div>
                <div className='live-timer-div'>
                    <Row>
                        <Col>
                            <span className='timer-counter'>بروز رسانی : <strong>{SelectCounter}</strong></span>
                            <select className='live-selectPicker'
                                    onChange={() => ChooseLiveRefresher()}
                                    id="chooseLiveRefresher"
                            >
                                <option value={20}>20</option>
                                <option value={30}>30</option>
                                <option value={40}>40</option>
                            </select>
                        </Col>
                        <Col>
                            <span className='name-state'>{singleCarInfo.NAME}</span>
                            <Button className='live-btn-close' onClick={() => HandleExit()}>
                                <img src={CloseBTN} alt=''/>
                            </Button>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    getMap: selectMap,
    isMain: selectIsMain,
    isLive: selectIsLive,
    getUser: selectUserInfo,
    singleCarData: selectSingleCarData,
    getMarkerLayers: selectIconsLayer,
    getReportLayer: selectReportLayer,
    getInterval: selectInterval,
    playPause: selectPlayPause,
    getReports: selectReports,
    singleCarInfo: selectSelectedCarInfo,
    SelectCounter: selectCounter,
    getTimer: selectTimer,
    getMountLiveTime: selectMountLiveTime,
    getIcon: selectCarIcons,
    CarsData: selectCarsData,
    getLivePath: selectLivePath,
    getUserInfo: selectUserInfo,
    getReportIndex: selectReportIndex,
    getToken: selectToken
});
const mapDispatchToProps = dispatch => ({
    ToggleIsLive: () => dispatch({type: mapTypes.TOGGLE_IS_LIVE}),
    ToggleIsMain: () => dispatch({type: mapTypes.TOGGLE_IS_MAIN}),
    setIconsLayer: icon => dispatch(SetIconsLayer(icon)),
    ClearIconsLayer: () => dispatch({type: mapTypes.CLEAR_ICONS_LAYER}),
    ClearReportLayer: () => dispatch({type: mapTypes.CLEAR_REPORT_LAYER}),
    SetReportIndex: index => dispatch(SetReportIndex(index)),
    setReports: reports => dispatch(GetReports(reports)),
    SetInterval: interval => dispatch(SetInterval(interval)),
    TogglePlayPause: () => dispatch({type: carsTypes.PLAY_PAUSE}),
    StartCountDown: () => dispatch({type: mapTypes.START_COUNT_DOWN}),
    SetTimer: timer => dispatch(SetTimer(timer)),
    RefreshCounter: liveTime => dispatch(SetCounterLiveShowTime(liveTime)),
    SetMountLiveTime: time => dispatch(SetMountLiveTime(time)),
    SetIcons: icon => dispatch(SetIcons(icon)),
    SetLivePath: livePath => dispatch(SetLivePath(livePath)),
    setCarsData: res => dispatch(GetCarsData(res)),
    setReportIndex: index => dispatch(SetReportIndex(index)),
    setReportLayer: newLayer => dispatch(AddReportLayer(newLayer)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiveComponent);